// src/app/features/auth/auth.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Rutas propias del módulo Auth
import { AuthRoutingModule } from './auth-routing.module';

// Componentes de Auth
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    // ...
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule, // Si usas formularios reactivos
    AuthRoutingModule    // Rutas específicas de Auth
  ]
})
export class AuthModule { }
